import { render, staticRenderFns } from "./ReserveInit.vue?vue&type=template&id=0bc04000&"
import script from "./ReserveInit.vue?vue&type=script&lang=js&"
export * from "./ReserveInit.vue?vue&type=script&lang=js&"
import style0 from "./ReserveInit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports